import { observer } from 'mobx-react-lite'
import { CalendarDropdown, FullPageWrapper, type ActionItem } from 'shared/ui'
import { AnalyticsHeader } from 'pages/analytics/ui'
import {
  CreditUsageSourcesProvider,
  useCreditUsageSourcesContext,
} from 'pages/analytics/pages/creditUsage/pages/sources/context/creditUsageSourcesContext'
import { SourceGroupFilter } from './SourceGroupFilter/SourceGroupFilter'
import { SourcesSummary } from './SourcesSummary/SourcesSummary'
import { SourcesTable } from './SourcesTable/SourcesTable'
import styles from './styles.module.scss'

const CreditUsageSourcesPageContent = observer(() => {
  const { calendarFilterStore, openExportModal } = useCreditUsageSourcesContext()

  const actions: ActionItem[] = [
    {
      text: 'Export data',
      icon: 'download',
      onAction: openExportModal,
    },
  ]

  return (
    <FullPageWrapper>
      <AnalyticsHeader title={'Credit usage: Sources'} actions={actions} />
      <div className={styles.filtersRow}>
        <CalendarDropdown store={calendarFilterStore} triggerProps={{ size: 'medium' }} />
        <SourceGroupFilter />
      </div>
      <SourcesSummary />
      <SourcesTable />
    </FullPageWrapper>
  )
})

export const CreditUsageSourcesPage = () => (
  <CreditUsageSourcesProvider>
    <CreditUsageSourcesPageContent />
  </CreditUsageSourcesProvider>
)
